import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

export type AlertVariant = 'filled' | 'outlined';
export type AlertSeverity = 'normal' | 'info' | 'success' | 'warning' | 'error';

const ALERT_ICONS_OUTLINED = {
    info: 'info_outlined',
    success: 'check_circle_outlined',
    warning: 'warning_amber',
    error: 'error_outlined'
};

const ALERT_ICONS = {
    info: 'info',
    success: 'check_circle',
    warning: 'warning',
    error: 'error'
};

@Component({
    selector: 'bp-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    exportAs: 'bpAlert',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        role: 'alert',
        '[class]': '"bp-alert" + (variant ? " bp-alert-" + variant : "") + (severity ? " bp-alert-" + severity : "")',
        '[class.dismissed]': 'dismissed',
        '[class.dismissible]': 'dismissible'
    }
})
export class AlertComponent {
    @Input() dismissed = false;

    private _dismissible: boolean = true;
    @Input()
    set dismissible(value: BooleanInput) {
        this._dismissible = coerceBooleanProperty(value);
    }
    get dismissible() {
        return this._dismissible;
    }

    @Input() icon: string;

    @Input() variant?: AlertVariant;

    @Input() severity?: AlertSeverity;

    dismiss() {
        this.dismissed = true;
    }

    _getIconName() {
        if (typeof this.icon !== 'undefined') return this.icon;
        const iconSet = this.variant === 'filled' ? ALERT_ICONS_OUTLINED : ALERT_ICONS;
        return iconSet[this.severity] ?? null;
    }
}
